module.exports = __webpack_public_path__ + "static/img/bg-en.6f8d5e76.png";